export const getPartsFromGeocoderResult = (
  place: google.maps.GeocoderResult,
) => {
  const parts: Record<string, string> = {};
  // this is a function to return these as state, city, etc
  place.address_components.forEach((component) => {
    component.types.forEach((type) => {
      parts[type] = component.long_name;
    });
  });
  const streetAddress = parts.street_number
    ? `${parts.street_number} ${parts.route}`
    : parts.route;
  return {
    city: parts.locality,
    county: parts.administrative_area_level_2,
    state: parts.administrative_area_level_1,
    zipCode: parts.postal_code,
    streetAddress,
    country: parts.country,
  };
};
